module.exports = __webpack_public_path__ + "static/img/infos-1-en.fae41ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/infos/img/infos-1-en.png
// module id = nMM0
// module chunks = 1